/**
 * @generated SignedSource<<da8e77d2850be2dc6f9f60c29b2f206c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSimilarSoldItemsColumn_item$data = {
  readonly displayPrice: ReadonlyArray<{
    readonly convertedAmountList: ReadonlyArray<{
      readonly amount: number | null;
      readonly currency: Currency | null;
    } | null> | null;
  } | null> | null;
  readonly localizedPdpUrl: string | null;
  readonly photoUrl: string | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly vertical: VerticalType | null;
  readonly " $fragmentSpreads": FragmentRefs<"getDetailLabelAndValue_item">;
  readonly " $fragmentType": "PdpSharedSimilarSoldItemsColumn_item";
};
export type PdpSharedSimilarSoldItemsColumn_item$key = {
  readonly " $data"?: PdpSharedSimilarSoldItemsColumn_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSimilarSoldItemsColumn_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "catchNonFatalErrors"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "priceBookName"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userCountryCode"
    },
    {
      "defaultValue": "",
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSimilarSoldItemsColumn_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": "photoUrl",
      "args": [
        {
          "kind": "Literal",
          "name": "size",
          "value": "master"
        }
      ],
      "kind": "ScalarField",
      "name": "firstPhotoWebPath",
      "storageKey": "firstPhotoWebPath(size:\"master\")"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "localizedPdpUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId"
        },
        {
          "kind": "Literal",
          "name": "canShowOnHoldForDifferentBuyer",
          "value": false
        },
        {
          "kind": "Variable",
          "name": "catchNonFatalErrors",
          "variableName": "catchNonFatalErrors"
        },
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "priceBookName",
          "variableName": "priceBookName"
        },
        {
          "kind": "Variable",
          "name": "userCountryCode",
          "variableName": "userCountryCode"
        }
      ],
      "concreteType": "ItemDisplayPriceType",
      "kind": "LinkedField",
      "name": "displayPrice",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ConvertedAmountList",
          "kind": "LinkedField",
          "name": "convertedAmountList",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "amount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "currency",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "getDetailLabelAndValue_item",
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemMeasurement",
          "kind": "LinkedField",
          "name": "measurement",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ItemConvertedMeasurementsType",
              "kind": "LinkedField",
              "name": "convertedMeasurementsList",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "measurementUnit",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "height",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "width",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "depth",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "diameter",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "secondaryHeight",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PdpDetail",
          "kind": "LinkedField",
          "name": "pdpDetailsDisplay",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "detailKey",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "detailValues",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "8a31505050f57ecdee5b0f2757ad36fd";

export default node;
